import React, { useEffect, useRef, useState } from "react";
import "./ContactSection.css";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { useForm, ValidationError } from "@formspree/react";

const ContactSection = () => {
  const [state, handleSubmit] = useForm("xanrvzee");
  const formRef = useRef(null);

  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (state.succeeded) {
      if (formRef.current) formRef.current.reset();
      setShowSuccess(true);

      const timer = setTimeout(() => setShowSuccess(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [state.succeeded]);

  return (
    <section id="contact" className="contact-section">
      <div className="contact-overlay" />
      <div className="contact-inner">
        <div className="contact-left">
          <h5>LET&apos;S WORK TOGETHER</h5>
          <h1>Get In Touch With Car Forensics LTD</h1>

          <div className="info-item">
            <div className="info-icon">
              <FaPhoneAlt />
            </div>
            <div className="info-text">
              <h4>Call Us:</h4>
              <p>
                <a href="tel:+447501911970">+44 7501 911970</a>
              </p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">
              <FaEnvelope />
            </div>
            <div className="info-text">
              <h4>Email Us:</h4>
              <p>
                <a href="mailto:carforensicsltd@gmail.com">
                  carforensicsltd@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="contact-card">
          <h2>Contact Us</h2>

          {showSuccess ? (
            <div className="success-message">
              <h3>✅ Message Sent Successfully!</h3>
              <p>Thank you for reaching out. We’ll get back to you shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} ref={formRef}>
              <div className="form-row">
                <input type="text" name="name" placeholder="Name" required />
                <input type="email" name="email" placeholder="Email" required />
              </div>

              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
                className="error-message"
              />

              <div className="form-row">
                <input type="text" name="number" placeholder="Number" required />
                <input type="text" name="subject" placeholder="Subject" required />
              </div>

              <div className="form-row" style={{ gridTemplateColumns: "1fr" }}>
                <textarea name="message" placeholder="Message" required />
              </div>

              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
                className="error-message"
              />

              <label className="contact-consent">
                <input type="checkbox" required />
                <span>
                  By using this form you agree with the storage and handling of your data by this website.
                </span>
              </label>

              <button
                type="submit"
                className="contact-submit"
                disabled={state.submitting}
              >
                {state.submitting ? "Sending..." : "SUBMIT"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
